var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2594_352)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2594_352)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.430664,
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_2594_352)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    d: "M-19.3479 10.5176V15.6397C-9.78311 19.6446 3.04054 22.0944 17.1356 22.0944C31.0977 22.0944 43.8124 19.6906 53.3478 15.7525V10.5176H-19.3479Z",
    fill: "url(#paint1_linear_2594_352)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.4307C18 10.1654 17.8946 9.91109 17.7071 9.72356C17.5196 9.53602 17.2652 9.43066 17 9.43066C16.7348 9.43066 16.4804 9.53602 16.2929 9.72356C16.1054 9.91109 16 10.1654 16 10.4307V15.4307H11C10.7348 15.4307 10.4804 15.536 10.2929 15.7236C10.1054 15.9111 10 16.1654 10 16.4307C10 16.6959 10.1054 16.9502 10.2929 17.1378C10.4804 17.3253 10.7348 17.4307 11 17.4307H16V22.4307C16 22.6959 16.1054 22.9502 16.2929 23.1378C16.4804 23.3253 16.7348 23.4307 17 23.4307C17.2652 23.4307 17.5196 23.3253 17.7071 23.1378C17.8946 22.9502 18 22.6959 18 22.4307V17.4307H23C23.2652 17.4307 23.5196 17.3253 23.7071 17.1378C23.8946 16.9502 24 16.6959 24 16.4307C24 16.1654 23.8946 15.9111 23.7071 15.7236C23.5196 15.536 23.2652 15.4307 23 15.4307H18V10.4307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 1.40688,
    y: 0.837543,
    width: 31.1862,
    height: 31.1862,
    rx: 7.59312,
    stroke: "url(#paint2_linear_2594_352)",
    strokeWidth: 0.813757,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2594_352",
    x: 0.186243,
    y: 0.430664,
    width: 33.6275,
    height: 36.0688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.25503
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.406879
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2594_352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2594_352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2594_352",
    x1: 17,
    y1: 0.430664,
    x2: 17,
    y2: 32.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1087B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2594_352",
    x1: 16.9999,
    y1: 9.97507,
    x2: 16.9999,
    y2: 22.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2594_352",
    x1: 17,
    y1: 0.430664,
    x2: 17,
    y2: 32.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2594_352"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.430664,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c37118a96a0332314032bebec25ab55f.svg";
export { ForwardRef as ReactComponent };